import React from 'react';
import PropTypes from 'prop-types';
import { Avatar } from 'shared-components/image/avatar';
import { FormBuilder } from 'shared-components/forms/form';
import { injectIntl } from 'react-intl';

class CommentTextArea extends React.Component {
  render () {
    return (
      <div className="flex comment-textarea-container">
        <hr />
        <div className="no-gutter-right-xs" style={{
          flexBasis: '16.6667%'
        }}>
          <Avatar id={this.props.profileAvatarID} src="/web-2/assets/images/no_avatar_placeholder.svg?v=rb" />
        </div>
        <div id="commentTextArea" className="text-right flex-one">
          <FormBuilder
            ref="commentForm"
            formname="commentform"
            formStyle="standard"
            formInputs={this.props.metaData}
            submitAction={this.props.actionFn}
            submitCallback={this.props.actionCb}
            isButtonDisabled={this.props.disabled}
            buttonText={ this.props.intl.formatMessage({ id: 'boards.comment_text_area.comment_button', defaultMessage: 'Comment' }) }
            buttonClass= "btn btn-secondary margin-lg-top"
            errorText={this.props.commentError}
            btnColSize={this.props.btnColSize}
            useBootstrapGrid={false}
          />
        </div>
      </div>
    );
  }
}

CommentTextArea.propTypes = {
  metaData: PropTypes.array,
  actionFn: PropTypes.func,
  actionCb: PropTypes.func,
  disabled: PropTypes.bool,
  commentError: PropTypes.string,
  btnColSize: PropTypes.string,
  profileAvatarID: PropTypes.string
};

exports.CommentTextArea = injectIntl(CommentTextArea);
